<template>
  <b-row>
    <b-col cols="12" class="pl-0 pr-0">
      <div>
        <span class="h6"><i class="far fa-file fa-lg mr-2"></i> {{ $t('views.excmcorrespondence.list.relatedCases') }}</span>
        <div class="float-right"> <button type='button' class="btn btn-info btn-circle btn-sm mt-0 mb-2 mr-0" v-b-tooltip.hover :title="$t('global.assignTask')" @click="showModalToAddRelatedCase()">
          <i class="fa fa-plus"></i>
        </button></div>
        <div v-if="relatedCases.length > 0">
          <table class="table table-hover table-sm table-striped mb-2">
            <tbody>
            <tr v-for="item in relatedCases" class="p-2" :key="item['@id']">
              <td>
                <span v-b-tooltip.hover :title="item.status.title" class="h6 mt-0 mb-0">
                    <i :class="item.status.class + ' fa-lg mr-2'" :style="'color: ' + item.status.color"></i>
                </span>
              </td>
              <td>
                <router-link
                             :to="{name: 'EXCMCaseShow', params: { id: item['@id'] }}">
                  <span v-if="item.number">{{item.number}}</span>
                  <span v-else>{{getIdLink(item['@id'])}}</span>
                </router-link>
              </td>
              <td>
                <div v-if="item.contractorUserData">
                  <span v-if="item.contractorUserData.firmname1">{{item.contractorUserData.firmname1}}</span>
                  <span v-else-if="item.contractorUserData.fullName">{{item.contractorUserData.fullName}}</span>
                  <div v-if="item.contractorUserData.phone">{{$t('views.excmcase.show.phone')}}: <phoneNumberLink :phoneNumber="item.contractorUserData.phone"/></div>
                  <div v-if="item.contractorUserData.mobilePhone">{{$t('views.excmcase.show.mobilePhone')}}: <phoneNumberLink :phoneNumber="item.contractorUserData.mobilePhone"/></div>
                  <div>{{ item.contractorUserData.fullAddress }}</div>
                  <div v-if="item.contractorUserData.userEmail"><a :href="'mailto:' + item.contractorUserData.userEmail">{{ item.contractorUserData.userEmail }}</a></div>
                  <div v-if="item.contractorUserData.contactEmail"><a :href="'mailto:' + item.contractorUserData.contactEmail">{{ item.contractorUserData.contactEmail }}</a></div>
                </div>
              </td>
              <td v-if="item.lastTask" class="text-center">
                <div class="mx-2">
                  {{item.lastTask.idTaskType.title}}
                </div>
              </td>
              <td>
                <span v-b-tooltip.hover :title="$t('views.excmcase.form.idPriority') + ' ' + item.idPriority.title" v-if="item.idPriority" class="h6 mt-0 mb-0"><i class="fa fa-circle fa-lg mr-2" :style="'color: ' + item.idPriority.backgroundColor"></i></span>
                <span style="visibility: hidden;" v-else class="h6 mt-0 mb-0"><i class="fa fa-circle fa-lg mr-2"></i></span>
                <router-link
                  :to="{name: 'EXCMCaseShow', params: { id: item['@id'] }}">
                  {{item.caseType.title}}
                </router-link>
              </td>
              <td>
                <button class="float-right btn btn-link fa fa-times fa-lg" v-b-tooltip.hover :title="$t('global.unAsignTask')" @click="deleteRelatedCase(item.relatedPivotId['@id'])"></button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          {{$t('global.noAssignedTasks')}}
        </div>
      </div>
    </b-col>
    <b-modal size="lg" ref="addRelatedCaseModal" hide-footer>
      <div slot="modal-header">
        <h6 class="modal-title m-0 float-left">
          {{$t('global.assignTask')}}
        </h6>
        <button type="button" aria-label="Close" class="close" @click="hideModalToAddRelatedCasse()">
          ×
        </button>
      </div>
      <b-row>
        <b-col cols="12">
          <b-form-group>
            <label
              for="excmnote_idCase"
              class="form-control-label">{{$t('views.excmnote.form.idCase')}}
            </label>
            <BaseSelectInput
              ref="caseInput"
              v-model="addRelatedCaseObject.idCaseRelated"
              :search-callback="caseSearchCallback"
              :display-values="['title', 'contractorUserData.fullName', 'contractorUserData.firmname1']"
              :query-param="'contractor'"
              :placeholder-autocomplete="'Zacznij wpisywać kontrahenta lub ID zlecenia'"
              :is-auto-complete-mode="isAutocompleteEnabledForCaseInput"
            ></BaseSelectInput>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col>
          <button @click="addRelatedCase()" class="btn btn-primary">{{ $t('buttons.save') }}</button>
          <b-btn @click="hideModalToAddRelatedCasse" variant="danger">{{ $t('buttons.close') }}</b-btn>
        </b-col>
      </b-row>
    </b-modal>
  </b-row>
</template>

<script>
import ApiService from '@/utils/ApiService'
import getIdFromLink from '@/utils/getIdFromLink'
import remove from '@/utils/remove'
import PhoneNumberLink from '@/components/Dashboard/Views/firm/components/PhoneNumberLink.vue'
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput.vue'

export default {
  name: 'CaseRelatedCases',
  components: {
    BaseSelectInput,
    PhoneNumberLink
  },
  props: {
    path: {
      required: true
    },
    fetchData: {
      required: true
    }
  },
  data () {
    return {
      addRelatedCaseObject: {
        idCase: this.path,
        idCaseRelated: ''
      },
      relatedCases: []
    }
  },
  watch: {
  },
  computed: {
    isAutocompleteEnabledForCaseInput () {
      return (this.$store.getters['configuration/enableAutoCompleteForUserData'])
    }
  },
  created () {
    this.fetchRelatedCases()
  },
  methods: {
    async fetchRelatedCases () {
      const response = await new ApiService(this.path + '/related_cases').getResults()
      this.relatedCases = response.items
    },
    deleteRelatedCase (id) {
      remove(id, () => {
        this.fetchData()
      })
    },
    getIdLink (link) {
      return getIdFromLink(link)
    },
    showModalToAddRelatedCase () {
      this.$refs.addRelatedCaseModal.show()
    },
    hideModalToAddRelatedCasse () {
      this.$refs.addRelatedCaseModal.hide()
    },
    async addRelatedCase () {
      await new ApiService('e_x_c_m_case_related_cases').post(this.addRelatedCaseObject)
      this.fetchData()
    },
    async caseSearchCallback (params = {}) {
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_c_m_cases', baseParams).getResults()
      return response.items
    }
  }
}
</script>
